import { type Common } from './common.js';
import { type SuccessResponse } from './models/common.js';
import { type Format, type Recording, type Timestamp } from './models/recording.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getByEncounterId(encounterId: string): Promise<Recording[]> {
    const url = this.common.constructPath(`/recording/encounter/${encounterId}`);
    const { recordings } = await this.common.getJSON(url);
    return recordings;
  }

  async register(args: {
    encounterId: string;
    timestamps: Timestamp[];
    format: Format;
    durationMillis: number;
  }): Promise<{ id: string; signedUploadURL: string }> {
    const url = this.common.constructPath('/recording/');
    return await this.common.postJSON(url, args);
  }

  async getSignedUploadURL(recording: Recording): Promise<string> {
    const url = this.common.constructPath(`/recording/${recording.id}/signedUploadURL`);
    const { signedUrl: signedUploadURL } = await this.common.getJSON(url);
    return signedUploadURL;
  }

  async markUploaded(recording: { id: string }): Promise<SuccessResponse> {
    const url = this.common.constructPath(`/recording/${recording.id}/uploaded`);
    return await this.common.putJSON(url);
  }

  getFileURL(recording: Recording): string {
    return this.common.constructPath(`/recording/${recording.id}/file`);
  }

  async downloadAudioFile(recording: Recording): Promise<string> {
    const url = this.getFileURL(recording);
    const { dataURL } = await this.common.getBlob(url);
    return dataURL;
  }
}
